import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import * as S from "effect/Schema";
import { PagingParams, pagedResponse } from "./paging.js";
import { PrincipalMiddleware } from "./principal.js";
/**
 * A `yp_notifications` row addressed to the caller — the side-nav inbox feed
 * (30s poll, infinite scroll). `id` is numeric: the one non-UUID primary key
 * on this contract, matching the underlying table.
 */
export const Notification = S.Struct({
    id: S.Int,
    timestamp: S.NullOr(S.String),
    status: S.NullOr(S.String),
    recipient: S.UUID,
    sender: S.NullOr(S.UUID),
    subject: S.String,
    message: S.NullOr(S.String),
    collection: S.NullOr(S.String),
    item: S.NullOr(S.String),
});
export const ListNotificationsParams = PagingParams;
export const ListNotifications = HttpApiEndpoint.get("listNotifications", "/notifications")
    .setUrlParams(ListNotificationsParams)
    .addSuccess(pagedResponse(Notification));
/** A generic by-id outcome for a notification the caller doesn't own. */
export const NotificationNotFound = S.Struct({
    _tag: S.Literal("NotificationNotFound"),
});
export const MarkNotificationReadPayload = S.Struct({
    id: S.Int,
});
const Ok = S.Struct({ ok: S.Literal(true) });
export const MarkNotificationRead = HttpApiEndpoint.post("markNotificationRead", "/notifications/read")
    .setPayload(MarkNotificationReadPayload)
    .addSuccess(S.Struct({ data: Ok }))
    .addError(NotificationNotFound, { status: 404 });
export const MarkNotificationsReadPayload = S.Struct({
    ids: S.Array(S.Int).pipe(S.minItems(1), S.maxItems(200)),
});
export const MarkNotificationsRead = HttpApiEndpoint.post("markNotificationsRead", "/notifications/read-many")
    .setPayload(MarkNotificationsReadPayload)
    .addSuccess(S.Struct({ data: S.Struct({ updated: S.Int }) }));
/** The tenant's feedback inbox couldn't be resolved (no contract-type mail target configured). */
export const FeedbackMailUnavailable = S.Struct({
    _tag: S.Literal("FeedbackMailUnavailable"),
});
export const SendFeedbackPayload = S.Struct({
    title: S.NonEmptyString,
    description: S.NonEmptyString,
});
/**
 * Routes the caller's own account and client into the feedback mail — the
 * legacy `/utils/send/feedback` payload carried `client_id`,
 * `user_id`/`user_email`/`user_first_name`/`user_last_name` as form fields;
 * here every one of them is resolved server-side from `CurrentPrincipal`,
 * never taken from the caller.
 */
export const SendFeedback = HttpApiEndpoint.post("sendFeedback", "/notifications/feedback")
    .setPayload(SendFeedbackPayload)
    .addSuccess(S.Struct({ data: Ok }))
    .addError(FeedbackMailUnavailable, { status: 409 });
export const notificationsGroup = HttpApiGroup.make("notifications")
    .add(ListNotifications)
    .add(MarkNotificationRead)
    .add(MarkNotificationsRead)
    .add(SendFeedback)
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=notifications.js.map